import { MutationOptions } from 'react-query';
import { ExitStatusResponse } from '../../schemas/ExitStatusResponseSchema';
import {
  submitSalesOnboarding,
  submitSalesProject,
} from './sales-projects.api';
import {
  SubmitSalesOnboardingRequest,
  SubmitSalesProjectRequest,
} from './sales-projects.api';
import { SubmitSalesProjectResponse } from './sales-projects.schema';

export const getSubmitSalesProjectMutation = (
  salesProjectId: number,
): MutationOptions<
  SubmitSalesProjectResponse,
  Error,
  SubmitSalesProjectRequest
> => ({
  mutationFn: body => submitSalesProject(salesProjectId, body),
});

export const getSubmitSalesOnboardingMutation = (): MutationOptions<
  ExitStatusResponse,
  Error,
  SubmitSalesOnboardingRequest
> => ({
  mutationFn: body => submitSalesOnboarding(body),
});
